module.exports = __webpack_public_path__ + "static/devil_mysterios-4e8c78d58a67c0e7e5748f8c0118e269.png";